import { render, staticRenderFns } from "./redHeadedFile.vue?vue&type=template&id=41a0004e&scoped=true"
import script from "./redHeadedFile.vue?vue&type=script&lang=js"
export * from "./redHeadedFile.vue?vue&type=script&lang=js"
import style0 from "./redHeadedFile.vue?vue&type=style&index=0&id=41a0004e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a0004e",
  null
  
)

export default component.exports